module.exports = __webpack_public_path__ + "img/contracts.b893dd48.svg";